import { MapScopedKeyMap } from 'ia-react-core/~/interfaces/MapScopedKeyMap';
import throwError from '../error/#throwError';
import getScoped from './getScoped';

/**
 * @since 1.0.0
 * @visibleName mapScoped
 * @component
 */
export default function mapScoped<State extends object>(
  state: State,
  keyMap: MapScopedKeyMap<State>,
  scope: string[] = [],
) {
  return getState(keyMap);

  function getState(currentKeyMap: MapScopedKeyMap<State>): Record<string, unknown> {
    if (typeof currentKeyMap === 'string') {
      return getScoped(state, currentKeyMap, scope);
    }

    if (Array.isArray(currentKeyMap)) {
      return currentKeyMap.reduce<Record<string, unknown>>((result, path) => {
        if (typeof path === 'string') {
          const prop = path.split('.').pop().replace('/', '');
          result[prop] = getState(path);
        } else {
          Object.assign(result, getState(path));
        }

        return result;
      }, {});
    }

    if (typeof currentKeyMap === 'object') {
      return Object.keys(currentKeyMap).reduce<Record<string, unknown>>((result, prop) => {
        const path = currentKeyMap[prop];
        result[prop] = getState(path);
        return result;
      }, {});
    }

    if (typeof currentKeyMap === 'function') {
      const result = currentKeyMap(state);
      return getState(result);
    }

    return throwError('mapScoped: Invalid arguments.');
  }
}
